import { render, staticRenderFns } from "./ViewBranch.vue?vue&type=template&id=cb5e04f8&"
import script from "./ViewBranch.vue?vue&type=script&lang=js&"
export * from "./ViewBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb5e04f8')) {
      api.createRecord('cb5e04f8', component.options)
    } else {
      api.reload('cb5e04f8', component.options)
    }
    module.hot.accept("./ViewBranch.vue?vue&type=template&id=cb5e04f8&", function () {
      api.rerender('cb5e04f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBranches/components/ViewBranch.vue"
export default component.exports